import { Show } from "solid-js";
import { ActionDropdown, ActivateDropdownItem, DeactivateDropdownItem, DeleteDropdownItem, EditDropdownMenuItemLink } from "../../components/ui/actions/ActionDropdown";
import { EditAction } from "../../components/ui/actions";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListRow } from "../../components/ui/list/ListRow";
import { Badge } from "@/components/ui/Badge";

import {
  TableCell,
} from "@/components/shadcn/table";

export default function AdminRow(props) {

  const row = props.item;

  const actionUrl = 'administrator';
  const entity = 'user';

  const onAction = (key) => {
    if (key === 'deactivate') {
      props.onAction(deactivateAction(actionUrl, entity), row.key);
      return;
    }

    if (key === 'activate') {
      props.onAction(activateAction(actionUrl, entity), row.key);
      return;
    }

    if (key === 'delete') {
      props.onAction(deleteAction(actionUrl, entity), row.key);
      return;
    }
  }

  const onHandle = () => {

  }

  return (
    <ListRow items={props.items} key={row.key} action={true} move={false} onToggle={(key) => props.onCheck(key)} onHandle={onHandle}>
      <TableCell class="w-[64px]">
        <img class="rounded-full me-2 my-2 w-[64px] h-[64px]" src={row.photoURL} alt="" />
      </TableCell>
      <TableCell>
        <h4 class="m-0 text-bold text-lg mb-0">
          <a class="kq_search" href="#">{row.name}</a>
        </h4>
        Email: <span class="text-muted-foreground">{row.email}</span> <br />
        Username: <span class="text-muted-foreground">{row.username}</span> <br />
        Created At: <Badge variant="success">{row.createdAt}</Badge>
      </TableCell>
      <TableCell>
        <div class="single-stat-box pull-left">
          <Badge variant={row.isActive ? 'success' : 'warning'}>{row.isActive ? 'Active' : 'Inactive'}</Badge>
          <br />
          <span class="text-muted-foreground">Status</span>
        </div>
      </TableCell>
      <TableCell class="text-right">
        <div class="flex gap-2 items-center">
          <ActionDropdown asIcon={true}>
            <EditDropdownMenuItemLink url={actionUrl} key={row.key} />
            <Show when={!row.isActive}>
              <ActivateDropdownItem onClick={() => { onAction('activate') }} />
            </Show>
            <Show when={row.isActive}>
              <DeactivateDropdownItem onClick={() => { onAction('deactivate') }} />
            </Show>
            <DeleteDropdownItem onClick={() => { onAction('delete') }} />
          </ActionDropdown>
        </div>
      </TableCell>
    </ListRow>
  );
}
